<template>
    <injury-donut :docs="docs" field="zone" :colors="colors" :label-fn="injuryZoneLabel"
        :center-label="$t('statistics.distinct_zones')" />
</template>

<script>
import InjuryDonut from './InjuryDonut.vue'

export default {
    name: 'InjuryZoneChart',
    components: { InjuryDonut },
    props: {
        docs: {
            type: Array,
            default: null,
        }
    },
    data() {
        return {
            colors: [
                '#009966', '#339999', '#66cccc', 'rgba(204,255,51,0.6)', '#66cc99',
            ],
        }
    },
}
</script>
